import { Card, Text, Button } from "@radix-ui/themes";

export function SuggestedReply() {
  return (
    <Card className="w-full p-4 bg-white shadow-sm">
      <Text size="2" weight="bold" className="mb-2">
        Suggested Reply
      </Text>
      <div className="space-y-4">
        <div className="border rounded-md p-3 bg-gray-50">
          <Text size="2">
            Thank you for reporting this issue. I've reviewed the error logs and
            it appears to be related to the database connection timeout. I'll
            investigate this further and update you with my findings.
          </Text>
        </div>
        <div className="flex gap-2">
          <Button variant="soft" size="1">
            Use This Reply
          </Button>
          <Button variant="outline" size="1">
            Regenerate
          </Button>
        </div>
      </div>
    </Card>
  );
}
